// extracted by mini-css-extract-plugin
module.exports = {"crossSellingItem":"CrossSelling_crossSellingItem__mUyqc","expanded":"CrossSelling_expanded__Qpn9_"};